var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _linearGradient, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _radialGradient25, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPolarBear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 526.897,
    cy: 196.357,
    gradientTransform: "matrix(.966 .259 -.404 1.508 56.632 -229.334)",
    gradientUnits: "userSpaceOnUse",
    r: 31.663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1055,
    stopColor: "#a0aab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dae4ea"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 93.64,
    cy: 100.346,
    gradientTransform: "matrix(.97 -.243 .193 .77 -16.541 45.876)",
    gradientUnits: "userSpaceOnUse",
    r: 46.762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daf1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6999,
    stopColor: "#c6d0da"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 57.586,
    cy: 101.552,
    gradientUnits: "userSpaceOnUse",
    r: 64.758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0138,
    stopColor: "#ecf9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#eaf3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#e7ecf1"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: -7.285,
    cy: 144.77,
    gradientUnits: "userSpaceOnUse",
    r: 87.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daf1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#dae4ea"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 150.761,
    cy: 222.268,
    gradientTransform: "matrix(.762 -.648 .647 .76 -107.865 151.033)",
    gradientUnits: "userSpaceOnUse",
    r: 107.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0aab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8745,
    stopColor: "#c6d0da"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: -723.024,
    cy: 191.794,
    gradientTransform: "matrix(-.762 -.648 -.647 .76 -245.677 -422.664)",
    gradientUnits: "userSpaceOnUse",
    r: 112.576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0aab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#b1bbc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6904,
    stopColor: "#c0cad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6d0da"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 62.368,
    cy: 345.053,
    gradientTransform: "matrix(.948 -.648 .806 .76 -203.376 123.186)",
    gradientUnits: "userSpaceOnUse",
    r: 42.607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6226,
    stopColor: "#d4dce4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6d0da"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 351.602,
    cy: 304.528,
    gradientTransform: "matrix(1 0 0 .731 0 82.079)",
    gradientUnits: "userSpaceOnUse",
    r: 99.332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    stopColor: "#a0aab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#c6d0da"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 196.397,
    cy: 354.916,
    gradientTransform: "matrix(.948 -.648 .806 .76 -171.506 212.429)",
    gradientUnits: "userSpaceOnUse",
    r: 30.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#d4dce4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9757,
    stopColor: "#c6d0da"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 283.7,
    cy: 148.094,
    gradientTransform: "matrix(.989 .15 -.099 .652 17.816 9.071)",
    gradientUnits: "userSpaceOnUse",
    r: 283.072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4039,
    stopColor: "#dde6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4886,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7296,
    stopColor: "#cad3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9433,
    stopColor: "#b9c1cb"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 243.211,
    cy: 248.701,
    gradientTransform: "matrix(.989 .15 -.098 .647 27.115 51.308)",
    gradientUnits: "userSpaceOnUse",
    r: 186.621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daf1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    stopColor: "#f3f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2474,
    stopColor: "#f6f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ccd6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7233,
    stopColor: "#a7b1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    stopColor: "#a0aab7"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 82.372,
    cy: 235.397,
    gradientTransform: "matrix(1 0 0 .889 0 26.039)",
    gradientUnits: "userSpaceOnUse",
    r: 116.429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    stopColor: "#909ba5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4283,
    stopColor: "#b9c1cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6678,
    stopColor: "#c7d0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9122,
    stopColor: "#dae4ea"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 215.713,
    cy: 222.268,
    gradientTransform: "matrix(.762 -.648 .647 .76 -92.372 193.135)",
    gradientUnits: "userSpaceOnUse",
    r: 107.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0aab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#aeb8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8745,
    stopColor: "#dae4ea"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.134,
    x2: 236.134,
    y1: 355.504,
    y2: 271.265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4435,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8198,
    stopColor: "#ced8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6d0da"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: -748.006,
    cy: 165.622,
    gradientTransform: "matrix(-.762 -.648 -.647 .76 -256.653 -445.134)",
    gradientUnits: "userSpaceOnUse",
    r: 112.576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2842,
    stopColor: "#eff4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6853,
    stopColor: "#e0e8ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dae4ea"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 114.518,
    cy: 345.053,
    gradientTransform: "matrix(.948 -.648 .806 .76 -187.883 156.99)",
    gradientUnits: "userSpaceOnUse",
    r: 42.607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2f4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dae4ea"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 378.487,
    cy: 227.918,
    gradientTransform: "matrix(.762 -.648 .647 .76 -57.201 300)",
    gradientUnits: "userSpaceOnUse",
    r: 150.935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    stopColor: "#c6d0da"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 387.292,
    cy: 235.271,
    gradientTransform: "matrix(.294 -.956 .612 .188 129.366 561.098)",
    gradientUnits: "userSpaceOnUse",
    r: 128.163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#e2f4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666,
    stopColor: "#e1f1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    stopColor: "#dce7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5537,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8101,
    stopColor: "#dfe7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7ecf1"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 248.547,
    cy: 354.916,
    gradientTransform: "matrix(.948 -.648 .806 .76 -156.013 246.233)",
    gradientUnits: "userSpaceOnUse",
    r: 30.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2f4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5773,
    stopColor: "#d3e1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6d0da"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 203.181,
    cy: 191.265,
    gradientTransform: "matrix(.356 -.935 .799 .304 -21.981 322.924)",
    gradientUnits: "userSpaceOnUse",
    r: 98.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0679,
    stopColor: "#ecf9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1534,
    stopColor: "#eff9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    stopColor: "#f6f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#f5f8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dae4ea"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 11.911,
    cy: 165.057,
    gradientUnits: "userSpaceOnUse",
    r: 40.872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1096,
    stopColor: "#e2f4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4961,
    stopColor: "#eef7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9188,
    stopColor: "#f6f9f9"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 118.6,
    cy: 166.387,
    gradientTransform: "matrix(.887 -.462 .366 .704 -47.535 104.004)",
    gradientUnits: "userSpaceOnUse",
    r: 106.375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4918,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6725,
    stopColor: "#ced7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#b9c1cb"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 124.11,
    cy: 100.346,
    gradientTransform: "matrix(.97 -.243 .193 .77 -15.627 53.281)",
    gradientUnits: "userSpaceOnUse",
    r: 46.762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2f4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6999,
    stopColor: "#dae4ea"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 141.919,
    cy: 128.216,
    gradientTransform: "matrix(.815 -.579 .599 .843 -50.606 102.327)",
    gradientUnits: "userSpaceOnUse",
    r: 20.466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2636,
    stopColor: "#d4dee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5691,
    stopColor: "#c6d0da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9c1cb"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 9.71,
    cy: 562.02,
    gradientTransform: "matrix(.762 -.571 .647 .669 -361.357 -196.553)",
    gradientUnits: "userSpaceOnUse",
    r: 21.572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0cee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3128,
    stopColor: "#a19dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5922,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665e66"
  }))), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 363.546,
    cy: 2401.748,
    gradientTransform: "matrix(.931 0 0 .112 -75.044 110.769)",
    gradientUnits: "userSpaceOnUse",
    r: 249.22
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#e3ebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#f6f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510.416 223.728c-24.613-6.595-39.219-31.894-32.624-56.506 24.613 6.594 39.219 31.893 32.624 56.506z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.804 127.809h-24.261v-7.999c0-8.981 7.281-16.262 16.262-16.262 4.418 0 7.999 3.581 7.999 7.999z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.121 119.785h-40.468c-22.89 0-42.046 15.986-46.912 37.404l72.724 9.209z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.288 187.166 4.495 8.534c2.266 4.301 6.727 6.994 11.589 6.994h5.785l.36.458c5.522 7.022 13.961 11.121 22.894 11.121h50.179v-47.035l-95.561 10.049c-1.405 3.05-1.42 6.692.259 9.879z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.222 360.279c0 10.245-8.305 18.549-18.549 18.549h-39.757v-117.99l58.307-10.003v109.444z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.043 166.406c20.223.432 36.179 17.432 36.179 37.66v87.234h-8.537c-36.142 0-65.441-29.299-65.441-65.441v-22.471c0-20.699 17-37.426 37.799-36.982z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.574 349.692h-8.23c-13.89 0-25.15 11.26-25.15 25.15v3.987h62.516c.001-16.092-13.044-29.137-29.136-29.137z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.753 248.207c0-25.452-20.378-46.143-45.708-46.65-26.181-.524-47.61 21.321-47.61 47.507v129.764h27.395c11.235 0 20.941-7.852 23.287-18.839l13.014-60.945c1.019-4.772 3.964-8.876 8.074-11.506 12.958-8.289 21.548-22.807 21.548-39.331z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.829 378.829c0-11.393-9.236-20.629-20.629-20.629h-5.827c-9.834 0-17.806 7.972-17.806 17.806v2.823z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.223 131.629c-12.446 0-24.309-4.667-33.913-12.583-5.291-4.362-12.037-6.902-19.221-6.902-4.745 0-9.298 1.109-13.368 3.118-5.765 2.847-12.035 4.523-18.464 4.523h-43.775l-33.793 90.36 27.584 6.583c10.016 4.415 20.681 6.311 31.627 6.311l22.81 5.81 54.29 33.319c37.273 26.266 75.508 45.978 121.105 45.978h43.729c36.027 0 66.84-25.899 73.037-61.389l2.892-16.565c10.881-62.318-37.079-119.378-100.34-119.378-24.146 0-48.008 5.211-69.956 15.276-7.959 3.65-16.613 5.54-25.369 5.54z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.868 227.911h-16.579c-10.946 0-21.771-2.28-31.787-6.695l-58.402-25.742-6.41 14.67 25.118 11.071c10.016 4.415 20.842 6.695 31.787 6.695h16.579l56.578 39.87c37.272 26.266 81.755 40.365 127.352 40.365h39.693c-45.598 0-90.08-14.099-127.352-40.365z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.483 119.785-33.793 90.36 14.936 6.583c13.896-5.334 23.759-18.803 23.759-34.576v-62.367z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.174 360.279c0 10.245-8.305 18.549-18.549 18.549h-39.757v-117.99l58.307-10.003v109.444z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.868 260.838v117.991h12.533v-120.141z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.995 166.406c20.223.432 36.179 17.432 36.179 37.66v87.234h-8.537c-36.142 0-65.441-29.299-65.441-65.441v-22.471c0-20.699 17-37.426 37.799-36.982z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.526 349.692h-8.23c-13.89 0-25.15 11.26-25.15 25.15v3.987h62.516c.001-16.092-13.044-29.137-29.136-29.137z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.705 248.207c0-25.452-20.378-46.143-45.708-46.65-26.181-.524-47.61 21.321-47.61 47.507v129.764h27.395c11.235 0 20.941-7.852 23.287-18.839l13.014-60.945c1.019-4.772 3.964-8.876 8.074-11.506 12.958-8.289 21.548-22.807 21.548-39.331z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.469 249.064c0-23.663 17.499-43.78 40.19-47.051-1.855-.263-3.744-.418-5.662-.456-26.181-.524-47.61 21.321-47.61 47.507v129.764h13.083v-129.764z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.781 378.829c0-11.393-9.236-20.629-20.629-20.629h-5.827c-9.834 0-17.806 7.972-17.806 17.806v2.823z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.729 225.858v-22.471c0-18.284 13.266-33.469 30.697-36.456-1.769-.306-3.582-.485-5.431-.525-20.799-.445-37.799 16.283-37.799 36.98v22.471c0 22.307 11.161 42.008 28.204 53.821v-11.329c-9.77-11.431-15.671-26.272-15.671-42.491z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.741 157.189-26.161 15.111c-2.072 1.197-3.618 2.961-4.551 4.987h95.561l7.875-20.098z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.015 119.785c-22.89 0-42.046 15.987-46.912 37.404l-26.161 15.111c-5.191 2.999-7.087 9.562-4.293 14.867l4.495 8.534c2.266 4.301 6.727 6.994 11.589 6.994h5.785l.36.458c5.522 7.021 13.961 11.121 22.894 11.121h35.687c20.447 0 37.023-16.576 37.023-37.023v-57.464h-40.467z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.274 127.809h-24.261v-7.999c0-8.981 7.281-16.262 16.262-16.262 4.418 0 7.999 3.581 7.999 7.999z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.002 127.809h-14.805v-4.174c0-5.871 4.76-10.631 10.631-10.631 2.305 0 4.174 1.869 4.174 4.174z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.762 182.455c0 2.905-5.723 8.592-9.362 8.592s-9.362-5.686-9.362-8.592c0-2.905 4.192-5.26 9.362-5.26s9.362 2.355 9.362 5.26z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.197 408.453c133.541 0 241.797-13.263 241.797-29.624h-483.594c0 16.361 108.256 29.624 241.797 29.624z",
    fill: "url(#SVGID_26_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolarBear);
export default __webpack_public_path__ + "static/media/icon-polar-bear.8078631482515c115c480c37fbbd3162.svg";
export { ForwardRef as ReactComponent };